import React, { useEffect, useContext, useState } from "react";
import GlobalStyle from "../../modules/globalStyles";
import { Route, Routes, BrowserRouter, Navigate } from "react-router-dom";
import Header from "../Header";
import Configurator from "../Configurator";
import Alerts from "../Alerts";
// import MyConfigurations from "../MyConfigurations";
import Loading from "../UI/Loading";
import Quote from "../Quote";
import QuoteDashboard from "../Quote/QuoteDashboard";
import Users from "../Administration/Users";
import UserDetails from "../Administration/UserDetails";
import Login from "../Login";
import ResetPassword from "../Administration/ResetPassword";
import { ThemeProvider } from "styled-components";
import * as _theme from "../../modules/theme";
import * as constants from "../../modules/constants";
import ProductForm from "../ProductManagement/ProductForm";
import ProductPage from "../ProductManagement";
import UserContext from "../../context/user/UserContext";
import PagerContextProvider from "../UI/Pager/PagerContext";
import ConfiguratorContextProvider from "../../context/configurator/ConfiguratorContextProvider";
import UserContextProvider from "../../context/user/UserContextProvider";
import SocketContextProvider from "../../context/socket/SocketContextProvider";
import AlertContextProvider from "../../context/alert/AlertContextProvider";
import Administration from "../Administration";
import PlatformSettings from "../Administration/PlatformSettings";
import PlatformsPage from "../Administration/PlatformsPage";
import StatusTypesPage from "../Administration/StatusTypesPage";
import CustomersPage from "../Administration/CustomersPage";
import CustomerForm from "../Administration/CustomerForm";
// import AddressesPage from "../Administration/AddressesPage";
import IssueReports from "../Administration/IssueReports";
import RolesPage from "../Administration/RolesPage";
import ThemesPage from "../Administration/ThemesPage";
import ThemeForm from "../Administration/ThemeForm";
import OrdersPage from "../OrdersPage";
import AllQuotes from "../Administration/AllQuotes";
import ThankYouPage from "../ThankYouPage";
import { PageWrapper } from "../UI/Grid";
import { Heading, Body } from "../UI/Text";
import { Box, Flex } from "reflexbox";
import Footer from "../Footer";
import { getTheme } from "../../requests/themeManagementRequests";
import { useQuery } from "../Hooks";
import GroupsPage from "../Administration/GroupsPage";
import GroupForm from "../Administration/GroupForm";
import RMAsPage from "../Administration/RMAsPage";
import RMAForm from "../Administration/RMAForm";
import HomePage from "../HomePage";
import ProductCatalog from "../ProductCatalog";
// import ProductPreview from "../ProductCatalog/ProductPreview";
import Interactions from "../Interactions";
import Maintenance from "../Maintenance";

const { DEFAULT_HOMEPAGE } = constants;

const RequireAuth = ({ children, loginPage, publicRoute }) => {
	const { activeUser, loggedIn, isLoading, platform } = useContext(UserContext);
	const { roleLevel } = activeUser || {};
	const homePage = DEFAULT_HOMEPAGE[roleLevel] || "/";
	const maintenanceMode = platform?.maintenanceMode;

	if (maintenanceMode) {
		return <Navigate to="/Maintenance" />;
	}

	if (loggedIn) {
		if (loginPage) return <Navigate to={homePage} />;
		if (isLoading || !activeUser || !platform) return <Loading />;
		// if (roleLevel > (publicRoute ? -1 : 0)) return children;
		// else return <Navigate to={homePage} />;
		return children;
	} else {
		if (publicRoute) return children;
		if (loginPage) return children;
		else return <Navigate to="/Login" />;
	}
};

const RequireAdmin = ({ children }) => {
	const { activeUser, loggedIn, isLoading, platform } = useContext(UserContext);
	const { roleLevel } = activeUser || {};

	const homePage = DEFAULT_HOMEPAGE[roleLevel] || "/";

	if (loggedIn) {
		if (isLoading || !activeUser || !platform) return <Loading />;
		if ([9, 5].includes(roleLevel)) return children;
		else return <Navigate to={homePage} />;
	} else {
		return <Navigate to="/Login" />;
	}
};

const App = () => {
	const context = useContext(UserContext);

	const themeResult = useQuery({
		queryID: "theme",
		request: getTheme,
		// skip: !context?.pid,
		queryVariables: {
			pid: context?.pid || "default",
			darkMode: !!context.darkMode,
		},
		forcedFilters: {},
	});

	const {
		data: themeData,
		setData: setThemeData,
		refetchQuery: refetchTheme,
		isLoading: themeLoading,
	} = themeResult || {};

	const [theme, setTheme] = useState({
		..._theme.airTractorTheme,
		breakpoints: themeData?.breakpoints
			? JSON.parse(themeData.breakpoints)
			: ["320px", "360px", "600px", "800px", "1000px", "1200px"],
	});

	useEffect(() => {
		if (themeData && !themeLoading) {
			setTheme({
				...themeData,
				breakpoints: themeData?.breakpoints
					? JSON.parse(themeData.breakpoints)
					: ["320px", "360px", "600px", "800px", "1000px", "1200px"],
			});
		}
	}, [context, themeData, themeLoading]);

	try {
		const { maintenanceMessage } = context?.platform || {};

		return (
			<ThemeProvider theme={theme}>
				<GlobalStyle />
				{context.isLoading ? (
					<Loading />
				) : (
					<Flex
						flexDirection="column"
						justifyContent="space-between"
						className="App"
					>
						<Alerts />

						<Flex flexDirection="column" justifyContent="flex-start">
							<Header refetchTheme={refetchTheme} />

							<Routes>
								<Route
									path="/Login"
									element={
										<RequireAuth loginPage>
											<Login />
										</RequireAuth>
									}
								/>
								<Route
									path="/Maintenance"
									element={
										<Maintenance maintenanceMessage={maintenanceMessage} />
									}
								/>
								<Route path="/ResetPassword" element={<ResetPassword />} />
								<Route
									path="/"
									element={
										<RequireAuth>
											<HomePage />
										</RequireAuth>
									}
								/>
								{/* <Route
                  path="/Preview/:id"
                  element={
                    <RequireAuth>
                      <ProductPreview />
                    </RequireAuth>
                  }
                /> */}

								<Route path="Configurator">
									<Route
										index
										element={
											<RequireAuth publicRoute>
												<Configurator />
											</RequireAuth>
										}
									/>
									<Route
										path=":productId/:quoteId/:configurationId"
										element={
											<RequireAuth publicRoute>
												<Configurator />
											</RequireAuth>
										}
									/>
								</Route>
								{/* <Route
                path="/MyConfigurations"
                element={
                  <RequireAuth publicRoute>
                    <PagerContextProvider
                      defaultOrder={["createdDate", "DESC"]}
                    >
                      <MyConfigurations />
                    </PagerContextProvider>
                  </RequireAuth>
                }
              /> */}
								<Route
									path="/Quote/:quoteId"
									element={
										<RequireAuth>
											<Quote />
										</RequireAuth>
									}
								/>
								<Route
									path="/DealerQuote/:quoteId"
									element={
										<RequireAuth>
											<Quote isDealer />
										</RequireAuth>
									}
								/>

								<Route
									path="/MyProfile/:username"
									element={
										<RequireAuth publicRoute>
											<UserDetails refetchTheme={refetchTheme} />
										</RequireAuth>
									}
								/>

								<Route
									path="/MyOrders/:username"
									element={
										<RequireAuth>
											<PagerContextProvider
												defaultOrder={["erpOrderNo", "DESC"]}
											>
												<OrdersPage />
											</PagerContextProvider>
										</RequireAuth>
									}
								/>
								<Route
									path="/Orders/:pid"
									element={
										<RequireAdmin>
											<PagerContextProvider
												defaultOrder={["erpOrderNo", "DESC"]}
											>
												<OrdersPage />
											</PagerContextProvider>
										</RequireAdmin>
									}
								/>
								<Route
									path="/Quotes/:pid"
									element={
										<RequireAdmin>
											<PagerContextProvider
												defaultOrder={["createdDate", "DESC"]}
											>
												<AllQuotes />
											</PagerContextProvider>
										</RequireAdmin>
									}
								/>
								<Route
									path="/ThankYou"
									element={
										<RequireAuth>
											<ThankYouPage />
										</RequireAuth>
									}
								/>

								<Route
									path="/QuoteDashboard"
									element={
										<RequireAuth>
											<QuoteDashboard />
										</RequireAuth>
									}
								/>
								<Route
									path="/Catalog"
									element={
										<RequireAuth>
											<PagerContextProvider defaultOrder={["Name", "ASC"]}>
												<ProductCatalog pageView />
											</PagerContextProvider>
										</RequireAuth>
									}
								/>
								<Route path="/Users">
									<Route
										index
										element={
											<RequireAdmin>
												<PagerContextProvider
													defaultOrder={["isLoggedIn", "DESC"]}
												>
													<Users />
												</PagerContextProvider>
											</RequireAdmin>
										}
									/>
									<Route path="/Users/:action">
										<Route
											index
											path="/Users/:action"
											element={
												<RequireAdmin>
													<UserDetails />
												</RequireAdmin>
											}
										/>
										<Route
											path="/Users/:action/:username"
											element={
												<RequireAdmin>
													<UserDetails />
												</RequireAdmin>
											}
										/>
									</Route>
								</Route>

								<Route path="/Products">
									<Route
										index
										element={
											<RequireAdmin>
												<PagerContextProvider
													defaultOrder={["ProductNumber", "ASC"]}
												>
													<ProductPage />
												</PagerContextProvider>
											</RequireAdmin>
										}
									/>
									<Route path="/Products/:action">
										<Route
											index
											path="/Products/:action"
											element={
												<RequireAdmin>
													<ProductForm />
												</RequireAdmin>
											}
										/>
										<Route
											path="/Products/:action/:id"
											element={
												<RequireAdmin>
													<ProductForm />
												</RequireAdmin>
											}
										/>
									</Route>
								</Route>

								<Route
									path="/Administration"
									element={
										<RequireAdmin>
											<Administration />
										</RequireAdmin>
									}
								/>

								<Route path="/Platforms">
									<Route
										path="/Platforms"
										element={
											<RequireAdmin superUser>
												<PlatformsPage />
											</RequireAdmin>
										}
									/>
									<Route path="/Platforms/:action">
										<Route
											index
											path="/Platforms/:action"
											element={
												<RequireAdmin>
													<PlatformSettings />
												</RequireAdmin>
											}
										/>
										<Route
											path="/Platforms/:action/:pid"
											element={
												<RequireAdmin>
													<PlatformSettings />
												</RequireAdmin>
											}
										/>
									</Route>
								</Route>

								<Route
									path="/StatusTypes"
									element={
										<RequireAdmin>
											<PagerContextProvider
												defaultOrder={["displayOrder", "ASC"]}
											>
												<StatusTypesPage />
											</PagerContextProvider>
										</RequireAdmin>
									}
								/>
								<Route
									path="/Customers/:pid"
									element={
										<RequireAdmin>
											<PagerContextProvider defaultOrder={["erpId", "DESC"]}>
												<CustomersPage />
											</PagerContextProvider>
										</RequireAdmin>
									}
								/>
								{/* <Route
                  path="/Addresses"
                  element={
                    <RequireAdmin>
                      <PagerContextProvider defaultOrder={["Address", "ASC"]}>
                        <AddressesPage />
                      </PagerContextProvider>
                    </RequireAdmin>
                  }
                /> */}
								<Route
									path="/IssueReports"
									element={
										<RequireAdmin>
											<PagerContextProvider
												defaultOrder={["createdAt", "DESC"]}
											>
												<IssueReports />
											</PagerContextProvider>
										</RequireAdmin>
									}
								/>
								<Route path="/Interactions">
									<Route
										index
										path="/Interactions"
										element={
											<RequireAdmin>
												<PagerContextProvider
													defaultOrder={["CreateDate", "DESC"]}
												>
													<Interactions />
												</PagerContextProvider>
											</RequireAdmin>
										}
									/>
									<Route
										path="/Interactions/:username"
										element={
											<RequireAuth>
												<PagerContextProvider
													defaultOrder={["CreateDate", "DESC"]}
												>
													<Interactions />
												</PagerContextProvider>
											</RequireAuth>
										}
									/>
								</Route>

								<Route
									index
									path="/Role/:pid"
									element={
										<RequireAdmin superUser>
											<RolesPage />
										</RequireAdmin>
									}
								/>
								<Route
									index
									path="/Themes/:pid"
									element={
										<RequireAdmin>
											<ThemesPage />
										</RequireAdmin>
									}
								/>
								<Route
									index
									path="/Theme/:id"
									element={
										<RequireAdmin>
											<ThemeForm
												setThemeData={setThemeData}
												refetchTheme={refetchTheme}
											/>
										</RequireAdmin>
									}
								/>
								<Route
									index
									path="/Customer/:id"
									element={
										<RequireAdmin>
											<CustomerForm
												setThemeData={setThemeData}
												refetchTheme={refetchTheme}
											/>
										</RequireAdmin>
									}
								/>
								<Route
									index
									path="/Groups/:pid"
									element={
										<RequireAdmin>
											<PagerContextProvider defaultOrder={["id", "ASC"]}>
												<GroupsPage />
											</PagerContextProvider>
										</RequireAdmin>
									}
								/>
								<Route
									index
									path="/Group/:id"
									element={
										<RequireAdmin>
											<PagerContextProvider defaultOrder={["username", "ASC"]}>
												<GroupForm />
											</PagerContextProvider>
										</RequireAdmin>
									}
								/>
								<Route
									index
									path="/RMAs/:pid"
									element={
										<RequireAuth>
											<PagerContextProvider
												defaultOrder={["createdAt", "DESC"]}
											>
												<RMAsPage />
											</PagerContextProvider>
										</RequireAuth>
									}
								/>
								<Route
									index
									path="/RMA/:id"
									element={
										<RequireAuth>
											<RMAForm />
										</RequireAuth>
									}
								/>
							</Routes>
						</Flex>
						<Footer />
					</Flex>
				)}
			</ThemeProvider>
		);
	} catch (error) {
		console.error(error);

		return (
			<ThemeProvider theme={theme}>
				<Box
					bg={theme.backgroundColor}
					style={{
						position: "absolute",
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
					}}
				>
					<PageWrapper>
						<Flex
							height="calc(100vh - 2rem)"
							alignItems="center"
							justifyContent="center"
							flexDirection="column"
						>
							<Heading
								style={{ fontFamily: "sans-serif" }}
								color={theme.textDark}
								center
							>
								Oops! Something went wrong...
							</Heading>
							<Body
								color={theme.textDark}
								style={{ flex: "unset", fontFamily: "sans-serif" }}
								center
							>
								Try refreshing the page, if that doesn't work please come back
								and try again later.
							</Body>
						</Flex>
					</PageWrapper>
				</Box>
			</ThemeProvider>
		);
	}
};

const AppContextReceiver = (props) => {
	return (
		<BrowserRouter>
			<React.StrictMode>
				<SocketContextProvider>
					<AlertContextProvider>
						<ConfiguratorContextProvider>
							<UserContextProvider {...props}>
								<App />
							</UserContextProvider>
						</ConfiguratorContextProvider>
					</AlertContextProvider>
				</SocketContextProvider>
			</React.StrictMode>
		</BrowserRouter>
	);
};

export default AppContextReceiver;
